import * as React from 'react';
import { observer } from 'mobx-react';

import { Viewport, ViewLarge, ViewSmall } from 'bernie-view';
import { RouteStore, ContextStore } from 'bernie-core';

import { TertiaryButtonTracked } from 'components/shared/tracked';
import { SortFilterStore, SearchCriteriaStore, AdvertisingStore } from 'stores';
import { useHydrationEnable, useStores } from 'utility/hooks';
import { Level, liveAnnounce } from 'uitk-react-utils';

export interface ClearSelectionsBtnProps {
  keySuffix: string;
  sortFilterStore?: SortFilterStore;
  searchCriteriaStore?: SearchCriteriaStore;
  routeStore?: RouteStore;
  advertisingStore?: AdvertisingStore;
  context?: ContextStore;
}

export const ClearSelectionsButton = observer((props: ClearSelectionsBtnProps) => {
  const hydrated = useHydrationEnable();
  const { sortFilterStore, searchCriteriaStore, routeStore, advertisingStore, context, analytics } = useStores();
  const { sortPresentation } = sortFilterStore;
  const loading = sortPresentation && sortPresentation.__typename === 'FlightsSortLoadingPresentation';
  const shouldBeDisabled = loading || !hydrated || !sortFilterStore.hasFiltersApplied();
  const { clearSelectionLabel } = sortFilterStore;
  const { label, accessibility } = clearSelectionLabel;

  const clearFilters = (e): void => {
    e.preventDefault();
    const { keySuffix } = props;
    sortFilterStore.clearFilters();
    liveAnnounce(accessibility.onCompletion, Level.POLITE);
    if (keySuffix === 'onACol') {
      sortFilterStore.applySortAndFilter(searchCriteriaStore, routeStore, advertisingStore, context, analytics);
    }
  };

  return (
    <Viewport>
      <ViewSmall>
        <TertiaryButtonTracked
          data-test-id="filter-clear-button"
          text={label}
          onClick={clearFilters}
          linkName={clearSelectionLabel.analytics && clearSelectionLabel.analytics.linkName}
          rfrr={clearSelectionLabel.analytics && clearSelectionLabel.analytics.rfrr}
          disabled={shouldBeDisabled}
          aria-label={accessibility && accessibility.usage}
        />
      </ViewSmall>
      <ViewLarge />
    </Viewport>
  );
});
